import { SimplePageHeader } from '@flexinet/ui-components';

export const AliasesPageHeader = () => {
    return <SimplePageHeader title="Aliases Management" tools={[]} />;
};
